import React from 'react';
import Icon from '@xo-union/tk-component-icons';

import styles from './index.scss';

interface Props {
  height?: string;
  text?: string;
}

const PhotoPlaceholder: React.FC<Props> = ({ height = '8.3125rem', text = 'Add a Photo' }) => {
  return (
    <div style={{ height }} className={styles.container}>
      <Icon className={styles.icon} size="md" name="add_circle" data-testid="photo-placeholder" /> {text}
    </div>
  );
};

export default PhotoPlaceholder;
